<app-table #history></app-table>
<!-- 
<table class="table table-striped">
    <thead>
        <tr>
            <th class="text-start">Detail</th>
            <th class="text-end">Debit</th>
            <th class="text-end">Credit</th>
            <th class="text-end" *ngIf="type == 'bank'">Tips</th>
            <th class="text-end" *ngIf="type == 'bank'">Profit</th>
            <th class="text-end">Date</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngIf="is_loading"><th colspan="11">Loading</th></tr>
        <tr *ngIf="!is_loading && summary.length == 0"><th colspan="10">No Data Available</th></tr>
        <tr *ngFor="let s of summary">
            <td class="text-start">{{s.vv}}</td>
            <td class="text-end">{{s.debit | number: '1.2-2'}}</td>
            <td class="text-end">{{s.credit | number: '1.2-2'}}</td>
            <td class="text-end" *ngIf="type== 'bank'">{{s.tips | number: '1.2-2'}}</td>
            <td class="text-end" *ngIf="type== 'bank'">{{s.profit | number: '1.2-2'}}</td>
          <td class="text-end">{{s.timestamp | date: 'medium'}}</td>
        </tr>
    </tbody>
    <tfoot>
        <tr>
            <td></td>
            <td>{{sum("debit") | number: '1.2-2'}}</td>
            <td>{{sum("credit") | number: '1.2-2'}}</td>
            <td *ngIf="type== 'bank'">{{sum("tips") | number: '1.2-2'}}</td>
            <td *ngIf="type== 'bank'">{{sum("profit") | number: '1.2-2'}}</td>
            <td></td>
        </tr>
    </tfoot>
</table> -->